import { useEffect } from 'react'
import { unstable_usePrompt } from 'react-router-dom'

export const usePrompt = ({
  when,
  message = 'Some files are still uploading. Are you sure you want to leave?',
}) => {
  useEffect(() => {
    if (when) {
      const handleBeforeUnload = (e) => {
        e.preventDefault()
        // Modern browsers will show their own message
        e.returnValue = message
        return message
      }

      window.addEventListener('beforeunload', handleBeforeUnload)
      return () =>
        window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [when, message])

  unstable_usePrompt({
    message,
    when: ({ currentLocation, nextLocation }) => {
      // Don't prompt if condition isn't active
      if (!when) return false

      // This handles cases like query param changes or hash changes
      const currentPathParts = currentLocation.pathname
        .split('/')
        .filter(Boolean)
      const nextPathParts = nextLocation.pathname.split('/').filter(Boolean)

      // If we're in a project and staying in same project
      if (
        currentPathParts.length >= 2 &&
        nextPathParts.length >= 2 &&
        currentPathParts[0] === nextPathParts[0] && // Same project
        currentPathParts[1] === nextPathParts[1] // Same route
      ) {
        return false
      }

      // In all other cases, show the prompt if the condition is active
      return when
    },
  })
}
